import type { BlogPost } from './types';
import { SHOPIFY_COHORT_ANALISI_PRODOTTI_RIACQUISTO_IT_BODY } from './articles/shopifyCohortAnalisiProdottiRiacquistoIt';
import { SHOPIFY_COHORT_ANALYSIS_REPEAT_PURCHASE_PRODUCTS_EN_BODY } from './articles/shopifyCohortAnalysisRepeatPurchaseProductsEn';
import { META_ADS_MCP_SHOPIFY_EN_BODY } from './articles/metaAdsMcpForShopifyEn';
import { META_ADS_MCP_SHOPIFY_IT_BODY } from './articles/metaAdsMcpPerShopifyIt';

/**
 * Elenco post pubblicati. Aggiungere qui solo articoli reali.
 * `category` deve coincidere con un valore in `blogCategories.ts` (es. "Profit Analytics").
 * Con `bodyMarkdown` compilato la pagina `/blog/:slug` è indicizzabile; senza, resta `noindex`.
 */
export const BLOG_MANIFEST: BlogPost[] = [
  {
    title:
      'Shopify Cohort Analysis: Find the Products That Drive Repeat Purchases',
    slug: 'shopify-cohort-analysis-repeat-purchase-products',
    language: 'en',
    translationKey: 'shopify-cohort-repeat-purchase-products',
    excerpt:
      'Learn how Shopify cohort analysis helps you see which first-purchase products create repeat customers, stronger LTV, better CAC payback and inventory-safe scaling.',
    category: 'Shopify Analytics',
    tags: [
      'Shopify cohort analysis',
      'repeat purchase rate',
      'LTV',
      'ecommerce analytics',
      'Shopify retention',
      'blended ROAS',
    ],
    publishedAt: '2026-05-11',
    readingTimeMinutes: 18,
    author: 'Kipify',
    seoTitle:
      'Shopify Cohort Analysis: Find Products That Drive Repeat Purchases',
    seoDescription:
      'Use Shopify cohort analysis to understand which first-purchase products generate repeat customers, LTV, CAC payback and profitable growth.',
    cardImageSrc: '/images/blog/shopify-cohort-analysis-en.png',
    bodyMarkdown: SHOPIFY_COHORT_ANALYSIS_REPEAT_PURCHASE_PRODUCTS_EN_BODY,
  },
  {
    title: 'Analisi cohort Shopify: trova i prodotti che generano riacquisti',
    slug: 'analisi-cohort-shopify-prodotti-riacquisto',
    language: 'it',
    translationKey: 'shopify-cohort-repeat-purchase-products',
    excerpt:
      'Scopri quali prodotti del primo ordine generano clienti di ritorno, LTV più alto e un migliore payback del CAC.',
    category: 'Shopify Analytics',
    tags: [
      'analisi cohort Shopify',
      'tasso di riacquisto',
      'LTV ecommerce',
      'Shopify retention',
      'analytics ecommerce',
      'blended ROAS',
    ],
    publishedAt: '2026-05-11',
    readingTimeMinutes: 18,
    author: 'Kipify',
    seoTitle:
      'Analisi cohort Shopify: trova i prodotti che generano riacquisti',
    seoDescription:
      'Scopri quali prodotti del primo ordine generano clienti di ritorno, LTV più alto e un migliore payback del CAC: cohort Shopify, riacquisti e decisioni operative.',
    cardImageSrc:
      '/images/blog/analisi-cohort-shopify-prodotti-riacquisto-it.png',
    cardImageAlt:
      'Analisi cohort Shopify: trova i prodotti che generano riacquisti — ' +
      'grafico e brand Kipify, articolo su cohort e riacquisti.',
    bodyMarkdown: SHOPIFY_COHORT_ANALISI_PRODOTTI_RIACQUISTO_IT_BODY,
  },
  {
    title:
      'Meta Ads MCP for Shopify: what it is, how it works, and why AI still needs profit data',
    slug: 'meta-ads-mcp-for-shopify',
    language: 'en',
    translationKey: 'meta-ads-mcp-shopify',
    excerpt:
      'Meta Ads MCP gives supported AI agents structured access to Meta Ads data. But to decide whether to scale a Shopify ecommerce business, you still need Shopify, Google Ads, GA4, margins, and inventory in the same picture.',
    category: 'AI Analytics',
    tags: [
      'Meta Ads',
      'MCP',
      'Shopify',
      'AI agents',
      'MER',
      'blended ROAS',
      'GA4',
      'profit analytics',
    ],
    publishedAt: '2026-05-03',
    updatedAt: '2026-05-04',
    readingTimeMinutes: 19,
    author: 'Kipify',
    seoTitle:
      'Meta Ads MCP for Shopify: what it is and why AI still needs profit data',
    seoDescription:
      'Meta Ads MCP gives supported AI agents structured access to Meta Ads. Scaling a Shopify store still takes Shopify, Google Ads, GA4, margins, and inventory in one picture.',
    cardImageSrc: '/images/blog/meta-ads-mcp-for-shopify-en.png',
    bodyMarkdown: META_ADS_MCP_SHOPIFY_EN_BODY,
  },
  {
    title:
      "Meta Ads MCP per Shopify: cos'è, come funziona e perché l'AI ha ancora bisogno di dati di profitto",
    slug: 'meta-ads-mcp-per-shopify',
    language: 'it',
    translationKey: 'meta-ads-mcp-shopify',
    excerpt:
      'Meta Ads MCP offre agli agenti AI supportati un accesso strutturato ai dati Meta Ads. Ma per decidere se scalare davvero un e-commerce Shopify servono anche Shopify, Google Ads, GA4, margini e inventario nello stesso quadro.',
    category: 'AI Analytics',
    tags: [
      'Meta Ads',
      'MCP',
      'Shopify',
      'AI agents',
      'MER',
      'blended ROAS',
      'GA4',
      'profit analytics',
    ],
    publishedAt: '2026-05-03',
    updatedAt: '2026-05-04',
    readingTimeMinutes: 19,
    author: 'Kipify',
    seoTitle:
      "Meta Ads MCP per Shopify: cos'è e perché l'AI ha ancora bisogno di dati di profitto",
    seoDescription:
      'Meta Ads MCP: accesso strutturato ai dati Meta Ads per agenti AI supportati. Per scalare su Shopify servono anche margini, inventario, GA4 e altri canali nello stesso quadro.',
    cardImageSrc: '/images/blog/meta-ads-mcp-per-shopify-it.png',
    bodyMarkdown: META_ADS_MCP_SHOPIFY_IT_BODY,
  },
];
